// import { Container, Row, Col } from "react-bootstrap";
import { Player } from 'video-react';
// import TrackVisibility from 'react-on-screen';
import {ProjectData} from './Project-data'
import { useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai"


export const Projects = () => {
  const [detail, setDetail] = useState([]);
  const [close, setClose] = useState(false);

  const detailPage = (Projects) => {
    setDetail([{...Projects}])
    setClose(true)
  }

  return (
    <div className='project' id="project">
        <h2>Projects</h2>

        {
          close ?
        
        <div className="detail-container">
        <div className="detail-content">
        <button className='close' onClick={()=> setClose(false)}><AiFillCloseCircle/></button>
        {
          detail.map((x) => {
            return(
              <>
              <div className="detail-info">
                <div className="img-box">
                  <Player src={x.vidUrl} alt={x.name}/>
                </div>
                <div className="project-details">
                  <h3>{x.name}</h3>
                  <p>{x.technology}</p>
                  <span><a href={x.WebUrl}>Visit Site</a></span>
                </div>
              </div>
              <p>{x.desc}</p>
              </>
            )
          })
        }
      </div>
    </div> :null
    }

    <div className="project-container">
      {
        ProjectData.map((curElm) =>
        {
          return(
            <>
            <div className="project-box">
              <div className="content">
                <div className="img-box">
                  <img src={curElm.imageUrl} alt={curElm.name}></img>
                </div>
                <div className="detail">
                  <div className="info">
                    <h3>{curElm.name}</h3>
                    <span>{curElm.technology}</span>
                  </div>
                  <button onClick={() => detailPage(curElm)}>See More</button>
                </div>
              </div>
            </div>
            </>
          )
        })
      }
    </div>
    </div>
    // <section className="project" id="project">
    //   <Container className="project-container">
    //      <h2>Projects</h2>
    //    {
      //   ProjectData.map( project => {
      //     return(



      //     <TrackVisibility>
      //           {({ isVisible }) =>
      //           <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
      // <Col xs={12} md={6} xl={6}>
      //   <Row>
      //       <div className="project-vid-container">
      //         <Player 
      //             key={project.id}
      //             src={project.vidUrl}
      //         />
      //       </div>
      //   </Row>
      //   <Row>
      //     <div className="project-desc">
      //       <h4 key={project.id}>{ project.name}</h4>
      //       <p key = {project.id}>{project.desc}</p>
      //       <span><a key={project.id} href={project.WebUrl}>Visit Site</a></span>
      //     </div>
      //   </Row>
      // </Col>
      // </div>}
      // </TrackVisibility>
    //   )
    // })
    // }
    //   </Container>
    // </section>
  )
}